import * as React from 'react';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const DefaultUnauthorizedSplash = _props => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      children: "Unauthorized"
    })
  });
};